import { render, staticRenderFns } from "./deleteMapping.vue?vue&type=template&id=c00a3ef4"
import script from "./deleteMapping.vue?vue&type=script&lang=js"
export * from "./deleteMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports